// extracted by mini-css-extract-plugin
export default {"empty":"Empty_empty__99Yrv","text":"Empty_text__TBYlI"};